import { IPublishTermsSchema } from '../../../../../repositories/monolith-python/entities/offer/PublishTermsSchema';
import { IPublishOfferRequest } from '../../../../../repositories/monolith-python/v3/publish-offer';
import { ICalltracking, IOfferState } from '../../../../reducers';
import { mapBargainTerms } from './mapBargainTerms';
import { mapBuilding } from './mapBuilding';
import { mapGeo } from './mapGeo';
import { mapHomeowner } from './mapHomeowner';
import { mapPartialRent } from './mapPartialRent';
import { mapPhones } from './mapPhones';
import { mapSelfEmployed } from './mapSelfEmployed';
import { mapVideos } from './mapVideos';

interface IParams {
  offer: IOfferState;
  calltracking: ICalltracking;
  publishTerms: IPublishTermsSchema | null;
  isArchived: boolean;
  isFromXml: boolean;
}

/**
 * Скопировано из ad-state.service, метод cleanAdModelWithMutate.
 * 1. От входного параметра isActiveDraft было решено отказаться, так как при публикации он не нужен.
 * 1.1. Также дополнительные условия на isActiveDraft мешают типизации.
 * 2. В других кейсах (сохранение черновика, публикация ЖК), пожалуй,
 * лучше скопировать этот кусок, убрать ненужное и добавить нужное.
 * 3. При публикации используется значение isActiveDraft = false
 */
export const getPublishParams = (params: IParams): IPublishOfferRequest => {
  const { offer, calltracking, publishTerms, isArchived, isFromXml } = params;

  const videos = mapVideos(offer);
  const geo = mapGeo(offer);
  const building = mapBuilding(offer);
  const partialRent = mapPartialRent(offer);
  const bargainTerms = mapBargainTerms(offer);
  const selfEmployedData = mapSelfEmployed(offer);
  const phones = mapPhones(offer, calltracking);
  const homeOwner = mapHomeowner(offer);

  // TODO: добавить adStateService.cleanModels

  return {
    offer: {
      ...offer,
      ...partialRent,
      ...(videos && { videos }),
      ...(geo && { geo }),
      ...(building && { building }),
      ...(bargainTerms && { bargainTerms }),
      ...(selfEmployedData && { selfEmployedData }),
      ...(phones && { phones }),
      ...(homeOwner && { homeOwner }),
      ...(publishTerms && { publishTerms }),
    },
    isArchived,
    isFromXml,
  } as unknown as IPublishOfferRequest;
};
